// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3VBF8","container":"styles_container__2p1QU","title":"styles_title__3YFIG","wrapper":"styles_wrapper__f9xgN","answer":"styles_answer__3SgAV"};